
import Vue from 'vue';
import SearchBar from '@/MarketSearch/components/SearchBar.vue';
import ListItem from "@/MarketSearch/components/ListItem.vue";

import { Component, Watch } from 'vue-property-decorator';
import { DistanceService } from '@/MarketSearch/services/DistanceService';
import { LocationInterface } from '@/shared/interfaces/LocationInterface';
import { GeoCoordinate } from '@/MarketSearch/services/GoogleMapsService';
import { LocationService } from '@/shared/services/LocationService';
import { TagManager, CATEGORY_GOOGLE_MAPS } from '../../js/modules/TagManager.js'
import { UserLocation } from '@/shared/services/UserLocation';
import { OfferService } from '@/shared/services/OfferService';
import {mapActions, mapGetters} from "vuex";

const EMPTY_VALUE = "no-selection"

@Component({
    name: 'offer-selection',
    components: {SearchBar, ListItem},
    methods: {
      ...mapActions([
        'setLocations'
      ])
    }
})
export default class App extends Vue {

    public searchTerm: string = '';
    public locations: Set<LocationInterface> = new Set();
    public value: string = this.$parent?.$data?.value || OfferService.getOfferLocation() || UserLocation.get() || '';
    public baseUrl: string = this.$parent?.$data?.baseUrl || '';
    public hasError: boolean = (this.$parent?.$data?.error === 'true') || false;
    public label: string = this.$parent?.$data?.label || '';
    public required: string = this.$parent?.$data?.required || '';
    public limitationOfLocationsEnabled = true;
    public disabled: boolean = false;
    public showResults: boolean = false;
    public gmapsAllowed: boolean = false;
    private lookingForLocation: boolean = false;
    private sortedByLocation: boolean = false;
    private storeLocation: boolean = false;
    public canUseLocation: boolean = false;
    public showLocationHint: boolean = false;
    private setLocations!: (payload: Set<LocationInterface>) => void;
    private readonly MAX_SHOWN_LOCATIONS = 3;


  get favoriteFilter() {
      return this.$parent.$data.favoriteFilter;
    }

    get possibleFavorites() {
      return this.$parent.$data.possibleFavorites;
    }

    constructor() {
        super();
        this.loadLocations();
        this.$nextTick(() => this.initTagManager());
        this.checkLocationAllowed();
    }

    initTagManager() {
        const tagManager = new TagManager();
        this.gmapsAllowed = tagManager.isCategoryAccepted(CATEGORY_GOOGLE_MAPS);
        this.disabled = !this.gmapsAllowed || (this.value === 'no-selection' && !this.hasError);
        this.label = (this.required !== null ? this.label + " " + this.required : this.label);
        tagManager.addEventListener('changed', (data: {categoryId: number, accepted: boolean}) => {
            const {categoryId, accepted} = data;
            if(categoryId === CATEGORY_GOOGLE_MAPS) {
                this.gmapsAllowed = accepted;
            }
        });
    }

    openTagManager() {
        (new TagManager()).open();
    }

    async loadLocations() {
        const locationService = new LocationService();
        const data = await locationService.fetchAll();
        this.limitationOfLocationsEnabled = !Array.from(data.locations).some(location => location.identifier === this.value);
        this.locations = data.locations;
        if(this.value == EMPTY_VALUE && UserLocation.has()) {
          const favorite = Array.from(this.locations).filter(location => location.identifier === UserLocation.get())[0]
          this.onSelectItem(favorite);
        }
    }

    async sortByUserLocation() {
      if(this.canUseLocation) {
        this.lookingForLocation = true;
        this.sortedByLocation = true;
        navigator.geolocation.getCurrentPosition(
            (pos) => this.searchByGeoCoordinate({lat: pos.coords.latitude, lng: pos.coords.longitude}),
            () => {
              this.sortedByLocation = false;
              this.lookingForLocation = false;
            }
        )
      } else {
        this.showLocationHint = true;
      }
    }

    searchByGeoCoordinate(geoCoordinate: GeoCoordinate) {
      this.setLocations(
          DistanceService.calculateList(
              geoCoordinate,
              this.locations
          )
      );
      this.onGeoSearch(geoCoordinate)
      this.lookingForLocation = false;
      this.$nextTick(this.updateLocations);
    }
    onGeoSearch(geoCoordinate: GeoCoordinate) {
        this.showResults = true;
        this.limitationOfLocationsEnabled = true;
        this.locations = DistanceService.calculateList(
            geoCoordinate,
            this.locations
        )
    }

    updateLocations() {
        this.locations = DistanceService.reset(this.locations);
    }

    onSelectItem(location: LocationInterface) {
        let loc = location.website?.substring(location.website?.lastIndexOf("/"));
        window.location.href = this.baseUrl + loc;
        if(!UserLocation.has()) this.activateFavorite(location || EMPTY_VALUE );
    }

    showMore() {
        this.limitationOfLocationsEnabled = false;
    }

    get shownLocations() {
        const locations = Array.from(this.locations).filter(location => location.keywords?.locationType === 'FOOD_SERVICE')
        if(this.limitationOfLocationsEnabled) {
          this.storeLocation = locations.slice(0, 4).filter(location => location.keywords?.storeLocation).length > 0;
          return locations.slice(0, 4);
        }
        this.storeLocation = true;
        return locations;
    }

    activateFavorite(location: LocationInterface) {
      if(location.identifier)
        UserLocation.set(location.identifier, location.city || '');
    }

    checkLocationAllowed() {
    let self = this;
    navigator.permissions && navigator.permissions.query({name: 'geolocation'}).then(function(PermissionStatus) {
      self.canUseLocation = PermissionStatus.state == 'granted';
      PermissionStatus.onchange = function() {
        if(this.state == "granted") {
          self.canUseLocation = true;
          self.showLocationHint = false;
        } else if(this.state == "denied") {
          self.canUseLocation = false;
        }
      };
    });
  }
}
